import angular from 'angular';

import RwPrivacyPolicyDialogComponent from './rw-privacy-policy-dialog-component';
import { RwPrivacyPolicyDialogController } from './rw-privacy-policy-dialog-controller';

export default angular
  .module('rw-privacy-policy-dialog', [])
  .controller('RwPrivacyPolicyDialogController', RwPrivacyPolicyDialogController)
  .component('rwPrivacyPolicyDialog', RwPrivacyPolicyDialogComponent);



// WEBPACK FOOTER //
// ./src/modules/utils/rw-privacy-policy/components/rw-privacy-policy-dialog-module.js